/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_pricing_commonfeatures_realtimecollaboration3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간 협업`)
};

const en_pricing_commonfeatures_realtimecollaboration3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-time Collaboration`)
};

const ja_pricing_commonfeatures_realtimecollaboration3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リアルタイム協業`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const pricing_commonfeatures_realtimecollaboration3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pricing_commonfeatures_realtimecollaboration3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pricing_commonfeatures_realtimecollaboration3", locale)
	if (locale === "ko") return ko_pricing_commonfeatures_realtimecollaboration3(inputs)
	if (locale === "en") return en_pricing_commonfeatures_realtimecollaboration3(inputs)
	return ja_pricing_commonfeatures_realtimecollaboration3(inputs)
};
export { pricing_commonfeatures_realtimecollaboration3 as "pricing_commonFeatures_realTimeCollaboration" }